const widgetsGroups = {
    'main': { key: 'main', title: '{{lang}}Mains' },
    'advenced': { key: 'advenced', title: '{{lang}}Advanceds' },
    'flowControl': { key: 'flowControl', title: '{{lang}}Flow Controls' },
}


const widgetsList = {

    // 'ProgressChart': {
    //     key: 'ProgressChart',
    //     title: '{{lang}}Progress Chart',
    //     label: '{{lang}}Progress Chart',
    //     icon: '/assets/icons/elements/chart (2).png',
    //     // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
    //     // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
    //     // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
    //     features: ["Tasking", "Settings"],
    //     parents: ["Tasking", "Settings"],

    //     types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],

    //     headers: [
    //         { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, icon: '/assets/icons/forms/date.png', placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
    //         {
    //             key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
    //             dependencies: [{
    //                 refKey: 'applet',
    //                 targetKey: 'frame',
    //                 conditions: {
    //                     root: {
    //                         id: 'root',
    //                         action: 'or',
    //                         conditions: {
    //                             1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
    //                             // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
    //                         }
    //                     },
    //                 },
    //                 show: true,
    //                 init: true,
    //                 changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
    //             }],
    //         },
    //         // { key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', } },
    //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true, defaultValue: '{{lang}}Progress Chart' } },
    //         { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '4', type: 'local', items: [{ value: '3', title: '25%' }, { value: '4', title: '33%' }, { value: '6', title: '50%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
    //         { key: 'min', type: 'NumberInput', col: '4', information: { label: '{{lang}}mininum', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insert', required: true, defaultValue: '0' } },
    //         { key: 'max', type: 'NumberInput', col: '4', information: { label: '{{lang}}maximum', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insert', required: true, defaultValue: '100' } },
    //         { key: 'unit', type: 'TextInput', col: '4', information: { label: '{{lang}}unit', default: '%', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insert', required: false } },

    //         // { key: 'reference', type: 'SelectInput', information: { label: '{{lang}}reference', address: 'getValuesWithData', filter: { page: 'brands' }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}insert', required: true }, showMain: false },

    //         {
    //             key: 'thing',
    //             type: 'AdvancedSelectInput',
    //             information: {
    //                 label: '{{lang}}thing',
    //                 address: 'getMyThings',
    //                 filter: { filter: {} },
    //                 fields: { title: 'name', image: 'images', value: '_id' },
    //                 type: 'api',
    //                 isSearchable: true,
    //                 icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
    //                 placeholder: '{{lang}}texts.addThing.findThing',
    //                 required: false,
    //             }
    //         },
    //         {
    //             key: 'characteristic',
    //             type: 'SelectInput',
    //             information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: false },
    //             dependencies: [{
    //                 refKey: 'thing',
    //                 targetKey: 'characteristic',
    //                 conditions: {
    //                     root: {
    //                         id: 'root',
    //                         action: 'and',
    //                         conditions: {
    //                             1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
    //                         }
    //                     },
    //                 },
    //                 show: true,
    //                 init: true,
    //                 changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    //             }],
    //             showMain: false
    //         },


    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],

    // },




    'ViewSwitcherWidget': {
        key: 'ViewSwitcherWidget',
        label: 'Records Viewer',
        icon: '/assets/icons/elements/archive.png',

        features: [],
        parents: ["general"],
        description: 'View records in table, card, calendar, board, and matrix format.',

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/icons/elements/secure.png', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'type', type: 'ImageSelectInput', information: { label: '{{lang}}View Type', default: 'table', inputClass: 'transparent', imageSize: 34, fontWeight: 400, default: 'line', col: '3', padding: '4px 10px', fontWeight: '500', type: 'local', items: [{ value: 'table', title: '{{lang}}Table', image: '/assets/icons/applets/database/table.svg' }, { value: 'card', title: '{{lang}}card', image: '/assets/icons/applets/database/card.svg' }, { value: 'calendar', title: '{{lang}}Calendar', image: '/assets/icons/applets/database/calendar.svg' }, { value: 'boards', title: '{{lang}}Boards', image: '/assets/icons/applets/database/kanban.svg' }, { value: 'matrix', title: '{{lang}}Matrix', image: '/assets/icons/applets/database/matrix.svg' }], placeholder: '{{lang}}select', required: true }, showMain: true },

            // TO DO: types should be double checked
            { key: 'collection', helperKey: 'frames', type: 'FrameSelectInput', information: { isSearchable: true, multiple: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true, appletHub: '{{appletHub}}', type: ['collection', 'folder'] }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type', mode: 'mode', name: 'name', cDate: 'cDate', applet: 'applet' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false }, },

            {
                key: 'filter', type: 'FilterInput', information: { isSearchable: true, multiple: true, label: '{{lang}}Query Filter', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Add filter to query?', required: false },
                dependencies: [
                    {
                        refKey: 'frames', targetKey: 'filter',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
                            effect: { changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                        }],
                        // else: { show: false },
                        init: true,

                    },
                ]
            },

            // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}insertLabel', defaultValue: '{{lang}}Updates', required: true } },

            {
                key: 'view.settings.cardInfo', type: 'CardBuilder', col: '12', information: { label: '{{lang}}Card Builder', placeholder: '{{lang}}Card Builder', inputClass: 'bordered-input p-0', required: true },

                dependencies: [{
                    refKey: ['type', 'frames'], targetKey: 'view.settings.cardInfo',
                    conditions: [{
                        root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'boards' } } } },
                        effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                    }],
                    else: { show: false },
                    init: true,
                    // show:true,

                }]
            },
            {
                key: 'view.settings.cardsInrow', type: 'ColumnsCountInput', col: '12', information: { label: '{{lang}}Cards in row', placeholder: '{{lang}}Cards in row', type: 'local', items: [{ value: 1, title: '{{lang}}1 Card' }, { value: 2, title: '{{lang}}2 Cards' }, { value: 3, title: '{{lang}}3 Cards' }, { value: 4, title: '{{lang}}4 Cards' }, { value: 5, title: '{{lang}}5 Cards' }, { value: 6, title: '{{lang}}6 Cards' }, { value: 7, title: '{{lang}}7 Cards' }, { value: 8, title: '{{lang}}8 Cards' }, { value: 9, title: '{{lang}}9 Cards' }, { value: 10, title: '{{lang}}10 Cards' }, { value: 11, title: '{{lang}}11 Cards' }, { value: 12, title: '{{lang}}12 Cards' }], required: true },
                dependencies: [{
                    refKey: 'type', targetKey: 'view.settings.cardsInrow',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,
                    // show:true,

                }]
            },




            {
                key: 'view.settings.stacked.date', type: 'ParamsInput', information: { label: '{{lang}}Date Field', validTypes: ['DateInput', 'DateTimeInput'], type: 'local', required: true, fields: { title: "information.label", value: "key" } },
                dependencies: [
                    // {
                    //     refKey: 'collection', targetKey: 'view.settings.stacked.date',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
                    //         effect: { changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                    //     }],
                    //     // else: { show: false },
                    //     init: true,
                    // },
                    {
                        refKey: ['type', 'frames'], targetKey: 'view.settings.stacked.date',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'calendar' } } }, },
                            effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                        }],
                        else: { show: false },
                        init: true,

                    }]
            },
            {
                key: 'view.settings.stacked.time', type: 'ParamsInput', information: { label: '{{lang}}Time Field', validTypes: ['TimeInput', 'DateTimeInput'], type: 'local', required: false, fields: { title: "information.label", value: "key" } },
                dependencies: [
                    // {
                    //     refKey: 'collection', targetKey: 'view.settings.stacked.time',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
                    //         effect: { changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                    //     }],
                    //     // else: { show: false },
                    //     init: true,

                    // },
                    {
                        refKey: ['type', 'frames'], targetKey: 'view.settings.stacked.time',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'calendar' } } }, },
                            effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                        }],
                        else: { show: false },
                        init: true,

                    }]
            },


            {
                key: 'view.settings.defaultView', type: 'SelectInput', information: { label: '{{lang}}Default view', type: 'local', required: true, default: 'month', items: [{ title: 'Day', value: "day" }, { title: 'Week', value: "weekSingleDay" }, { title: 'Month', value: "month" }] },
                dependencies: [

                    {
                        refKey: ['type',], targetKey: 'view.settings.defaultView',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'calendar' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }]
            },


            {
                key: 'view.settings.canNotSwitchView', type: 'SwitchInput', information: { label: '{{lang}}Prevent switching view type?', type: 'local', default: false },
                dependencies: [

                    {
                        refKey: ['type',], targetKey: 'view.settings.canNotSwitchView',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'calendar' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }]
            },



            {
                key: 'view.settings.availableViews', type: 'MultiSelectInput', information: { label: '{{lang}}Available views', type: 'local', default: ['month', 'weekSingleDay', 'day'], items: [{ title: 'Day', value: "day" }, { title: 'Week', value: "weekSingleDay" }, { title: 'Month', value: "month" }], hint: '{{lang}}Default view will always be included by default.', },
                dependencies: [

                    {
                        refKey: ['type', 'view.settings.canNotSwitchView'], targetKey: 'view.settings.availableViews',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'calendar' } }, 2: { id: 2, source: { value: '@data.view.settings.canNotSwitchView' }, operator: { value: '!=' }, target: { value: true } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }]
            },




            // {
            //     key: 'view.settings.stacked.row', type: 'ParamsInput', information: { label: '{{lang}}Group field', validTypes: ['LocalSelectInput', 'SelectInput', 'MultiSelectInput', 'AdvancedSelectInput', 'GlobalUserInput', 'DateInput', 'TimeInput', 'DateTimeInput'], required: false },
            //     dependencies: [{
            //         refKey: 'collection', targetKey: 'view.settings.stacked.row',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
            //             effect: { changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
            //         }],
            //         init: true,

            //     },
            //     {
            //         refKey: 'type', targetKey: 'view.settings.stacked.row',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'calendar' } } }, },
            //             effect: { show: true }
            //         }],
            //         else: { show: false },
            //         init: true,

            //     }]
            // },




            // Boards
            {
                key: 'view.settings.stacked.stackedField', type: 'ParamsInput', information: { label: '{{lang}}Stack field', validTypes: ['LocalSelectInput', 'SelectInput', 'MultiSelectInput', 'AdvancedSelectInput', 'GlobalUserInput', 'DateInput', 'TimeInput', 'DateTimeInput'], required: false },
                dependencies: [
                    //     {
                    //     refKey: 'collection', targetKey: 'view.settings.stacked.stackedField',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
                    //         effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                    //     }],
                    //     init: true,

                    // },
                    {
                        refKey: ['type', 'frames'], targetKey: 'view.settings.stacked.stackedField',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'boards' } } }, },
                            effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                        }],
                        else: { show: false },
                        init: true,

                    }]
            },




            // Matrix

            {
                key: 'view.settings.stacked.row', type: 'ParamsInput', information: { label: '{{lang}}Row Stack', validTypes: ['LocalSelectInput', 'SelectInput', 'MultiSelectInput', 'AdvancedSelectInput', 'GlobalUserInput', 'DateInput', 'TimeInput', 'DateTimeInput'], required: true },
                dependencies: [
                    //     {
                    //     refKey: 'collection', targetKey: 'view.settings.stacked.row',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
                    //         effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                    //     }],
                    //     init: true,

                    // },
                    {
                        refKey: ['type', 'frames'], targetKey: 'view.settings.stacked.row',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'matrix' } }, }, },
                            effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                        }],
                        else: { show: false },
                        init: true,

                    }]
            },

            {
                key: 'view.settings.stacked.column', type: 'ParamsInput', information: { label: '{{lang}}Column Stack', validTypes: ['LocalSelectInput', 'SelectInput', 'MultiSelectInput', 'AdvancedSelectInput', 'GlobalUserInput', 'DateInput', 'TimeInput', 'DateTimeInput'], required: true, },
                dependencies: [
                    //     {
                    //     refKey: 'collection', targetKey: 'view.settings.stacked.column',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
                    //         effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                    //     }],
                    //     init: true,

                    // },
                    {
                        refKey: ['type', 'frames'], targetKey: 'view.settings.stacked.column',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'matrix' } } }, },
                            effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                        }],
                        else: { show: false },
                        init: true,

                    }]
            },



            {
                key: 'view.settings.stacked.viewKey', type: 'ParamsInput', information: { label: '{{lang}}Main Card Field', required: true, hint: '{{lang}}You can customize card view using the toolbar -> Data -> Customize card.' },
                dependencies: [
                    //     {
                    //     refKey: 'collection', targetKey: 'view.settings.stacked.viewKey',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
                    //         effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                    //     }],
                    //     init: true,

                    // },
                    {
                        refKey: ['type', 'frames'], targetKey: 'view.settings.stacked.viewKey',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'matrix' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'calendar' } } }, },
                            effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.frames' }] }
                        }],
                        else: { show: false },
                        init: true,

                    }]
            },




            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },






    'ChartWidget': {
        key: 'ChartWidget',
        title: 'Chart Widget',
        label: 'Chart Widget',
        type: 'ChartWidget',
        icon: '/assets/icons/elements/chart (3).png',
        description: 'Advanced report and chart widget with including 12 different chart types.',

        features: ["Tasking", 'all'],
        parents: ["Tasking", 'all'],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [

            { key: 'type', type: 'ImageSelectInput', information: { label: '{{lang}}Chart Type', col: 5, fontWeight: 500, fontSize: 12, inputClass: 'transparent', imageSize: 34, default: 'line', type: 'local', items: [{ value: 'line', title: 'Line', image: '/assets/icons/charts/line-chart (1).png' }, { value: 'bar', title: 'Bar', image: '/assets/icons/charts/bar-chart (5).png' }, { value: 'pie', title: 'Pie', image: '/assets/icons/charts/pie-chart.png' }, { value: 'radar', title: 'Radar', image: '/assets/icons/charts/octagonal.png' }, { value: 'polar', title: 'Polar', image: '/assets/icons/charts/pie-chart (1).png' }, { value: 'bubble', title: 'Bubble', image: '/assets/icons/charts/pie-chart (2).png' }, { value: 'scatter', title: 'Scatter', image: '/assets/icons/charts/chart (1).png' }, { value: 'treemap', title: 'Treemap', image: '/assets/icons/charts/treemap-chart.png' }, { value: 'gauge', title: 'Gauge', image: '/assets/icons/charts/speedometer.png' }, { value: 'funnel', title: 'Funnel', image: '/assets/icons/charts/funnel.png' }, { value: 'boxPlot', title: 'Box Plot', image: '/assets/icons/charts/bar-chart (2).png' }, { value: 'word', title: 'Word Cloud', image: '/assets/icons/charts/speech-bubble.png' }], placeholder: '{{lang}}select', required: true }, showMain: true },
            {
                key: 'style', type: 'ImageSelectInput', information: { label: '{{lang}}Chart Style', fontWeight: 500, fontSize: 12, inputClass: 'transparent', imageSize: 34, default: 'line', col: '5', type: 'local', items: [], placeholder: '{{lang}}select', required: true },
                dependencies: [{
                    refKey: 'type', targetKey: 'style',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'bar' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'required', value: true }, { key: 'information.items', value: [{ value: 'vertical', title: 'Vertical Chart', image: '/assets/icons/charts/bar.png' }, { value: 'vertical_stacked', title: 'Vertical Stacked', image: '/assets/icons/charts/pie.png' }, { value: 'vertical_full_stacked', title: 'Vertical Full Stacked', image: '/assets/icons/charts/Donut.png' }, { value: 'horizontal', title: 'Horizontal Chart', image: '/assets/icons/charts/bar.png' }, { value: 'horizontal_stacked', title: 'Horizontal Stacked', image: '/assets/icons/charts/pie.png' }, { value: 'horizontal_full_stacked', title: 'Horizontal Full Stacked', image: '/assets/icons/charts/Donut.png' }] }] }
                    }, {
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'line' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'required', value: true }, { key: 'information.items', value: [{ value: 'time_series', title: 'Time series', image: '/assets/icons/charts/bar.png' }, { value: 'smoothed_time_series', title: 'Smoothed time series', image: '/assets/icons/charts/pie.png' }, { value: '100_stacked', title: '100% Stacked', image: '/assets/icons/charts/Donut.png' }] }] }
                    },
                    {
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'pie' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'required', value: true }, { key: 'information.items', value: [{ value: 'pie', title: 'Pie Chart', image: '/assets/icons/charts/pie.png' }, { value: 'donut', title: 'Donut Chart', image: '/assets/icons/charts/Donut.png' }, { value: 'radial', title: 'Radial Chart', image: '/assets/icons/charts/bar.png' },] }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'required', value: false }] },
                    init: true,
                    // show:true,

                }],
                showMain: true
            },

            // { key: 'extraSection', type: 'FormSection', col: '12', pages: ['information'], information: { label: '{{lang}}settings', tabs: [{ key: 'settings', label: '{{lang}}Settings' }, { key: 'appearance', label: '{{lang}}Appearance' }], required: false }, showMain: false },

            { key: 'collection', type: 'AdvancedMultiTreeSelect', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false }, },

            // { key: 'collection', type: 'MultiTreeSelectAddListing', col: '12', information: { label: '{{lang}}Collection', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
            {
                key: 'x_axis', type: 'SelectInput', information: { label: '{{lang}}X-Axis', type: 'api', address: 'getFrameFields', fetchKey: 'fields', filter: { _id: "{{collection}}" }, fields: { title: 'information.label', value: 'key' }, placeholder: '{{lang}}select', required: true },
                dependencies: [{
                    refKey: 'collection', targetKey: 'x_axis',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collection' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { changeHeader: [{ key: 'disabled', value: false }] }
                    }],
                    else: { changeHeader: [{ key: 'disabled', value: true }] },
                    init: true,
                    // show:true,

                }], disabled: false
            },
            {
                key: 'value', type: 'SelectInput', information: { label: '{{lang}}Value', type: 'api', address: 'getFrameFields', fetchKey: 'fields', filter: { _id: "{{collection}}" }, fields: { title: 'information.label', value: 'key' }, placeholder: '{{lang}}select', required: true },
                dependencies: [{
                    refKey: 'collection', targetKey: 'value',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collection' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { changeHeader: [{ key: 'disabled', value: false }] }
                    }],
                    else: { changeHeader: [{ key: 'disabled', value: true }] },
                    init: true,
                    // show:true,

                }], disabled: false
            },

            {
                key: 'groupBy', type: 'ChartFieldInput', information: { label: '{{lang}}Group by', type: 'api', address: 'getFrameFields', fetchKey: 'fields', filter: { _id: "{{collection}}" }, fields: { title: 'information.label', value: 'key' }, placeholder: '{{lang}}select', required: true },
                dependencies: [{
                    refKey: 'collection', targetKey: 'groupBy',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collection' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { changeHeader: [{ key: 'disabled', value: false }] }
                    }],
                    else: { changeHeader: [{ key: 'disabled', value: true }] },
                    init: true,
                    // show:true,

                }], disabled: false
            },


            // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}insertLabel', defaultValue: '{{lang}}Chart', required: true } },
            {
                key: 'timeUnit', type: 'SelectInput', information: { label: '{{lang}}Time unit', default: 'year,month', type: 'local', items: [{ value: 'year', title: '{{lang}}Year' }, { value: 'year,quarter', title: '{{lang}}Year Quarter' }, { value: 'year,month', title: '{{lang}}Year Month' }, { value: 'year,week', title: '{{lang}}Year Week' }, { value: 'year,dayOfMonth', title: '{{lang}}Year Month day' }, { value: 'quarter', title: '{{lang}}Quarter' }, { value: 'month', title: '{{lang}}Month' }, { value: 'dayOfMonth', title: '{{lang}}Day of Month' }, { value: 'week_number', title: '{{lang}}Week Number' }, { value: 'week_day', title: '{{lang}}Week Day' }, { value: 'dayOfMonth', title: '{{lang}}Day of month' }], placeholder: '{{lang}}select', required: false },
                dependencies: [{
                    refKey: 'type', targetKey: 'timeUnit',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'line' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'disabled', value: false }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'disabled', value: true }] },
                    init: true,
                    // show:true,

                }],
                showMain: true
            },


            { key: 'maxValue', type: 'NumberInput', col: '12', information: { label: '{{lang}}Max Value', placeholder: '{{lang}}Max Value', required: true } },


            // {
            //     key: 'thing',
            //     type: 'AdvancedSelectInput',
            //     information: {
            //         label: '{{lang}}thing',
            //         address: 'getMyThings',
            //         filter: { filter: {} },
            //         fields: { title: 'name', image: 'images', value: '_id' },
            //         type: 'api',
            //         isSearchable: true,
            //         icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',

            //         placeholder: '{{lang}}texts.addThing.findThing',
            //         required: false,
            //     }
            // },
            // {
            //     key: 'characteristic',
            //     type: 'MultiSelectInput',
            //     information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: false },
            //     dependencies: [{
            //         refKey: 'thing',
            //         targetKey: 'characteristic',
            //         conditions: {
            //             root: {
            //                 id: 'root',
            //                 action: 'and',
            //                 conditions: {
            //                     1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
            //                 }
            //             },
            //         },
            //         show: true,
            //         init: true,
            //         changeHeader: { key: 'information.filter.id', value: '@data.thing' },

            //     }],
            //     showMain: false
            // },

            // { key: 'reference', type: 'SelectInput', information: { label: '{{lang}}reference', address: 'getValuesWithData', filter: { page: 'brands' }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}insert', required: true }, showMain: false },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },





    'FormWidget': {
        key: 'FormWidget',
        type: 'FormWidget',
        label: 'Form View',
        icon: '/assets/icons/elements/clipboard.png',
        description: 'Use forms and collect data for your collections using this widget',
        parents: ['all'],

        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'collection', secondKey: 'collectionApplet', type: 'AdvancedMultiTreeSelect', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false }, },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },


    'FilterWidget': {
        key: 'FilterWidget',
        label: 'Filter Widget',
        icon: '/assets/icons/elements/document.png',
        description: 'Create dynamic filters for records and charts of the page',

        features: [],
        parents: ["general"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'source', type: 'ParamsInput', col: '12', information: { label: '{{lang}}Dynamic Source', validTypes: ['VideoInput'], placeholder: '{{lang}}< Custom Source >', required: false } },


            { key: 'showCover', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show Cover Image', placeholder: '', required: false } },

            { key: 'showDuration', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show Video Duration', placeholder: '', required: false } },

            {
                type: 'VideoInput', key: 'image', col: '12', information: { label: '{{lang}}Custom Video', singleRow: true, placeholder: '{{lang}}Select Video', required: true, single: true },
                dependencies: [{
                    refKey: 'source', targetKey: 'image',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.source' }, operator: { value: '==' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'required', value: false }] },
                    init: true,
                    // show:true,

                }]
            },

            { key: 'antecedent', type: 'NumberInput', col: '6', information: { label: '{{lang}}Ratio', placeholder: '{{lang}}Antecedent' } },
            { key: 'consequent', type: 'NumberInput', col: '6', information: { label: '\u200B', placeholder: '{{lang}}Consequent' } },

            { key: 'objectFit', type: 'SelectInput', information: { label: '{{lang}}Object fit', default: 'cover', defaultValue: 'cover', type: 'local', items: [{ value: 'cover', title: '{{lang}}Cover' }, { value: 'fit', title: '{{lang}}fit' }, { value: 'fill', title: '{{lang}}Fill' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false, defaultValue: 'bar' }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },


    'TextWidget': {
        key: 'TextWidget',
        label: 'Text Widget',
        icon: '/assets/icons/elements/text (2).png',

        features: [],
        parents: ["general"],
        description: 'Insert dynamic and/or static text and edit its style',
        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],

        sizes: {
            min: { xs: 50, md: 20, lg: 10 },
            suitable: { xs: 100, md: 100, lg: 50 },
            max: { xs: 100, md: 100, lg: 100 },
        },


        headers: [
            // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title',  placeholder: '{{lang}}text', required: false } },

            { key: 'content', type: 'TextEditorInput', col: '12', information: { label: '{{lang}}content', showToolbar: true, placeholder: '{{lang}}text', style: { minHeight: 150 }, required: true } },
            // { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '4', defaultValue: '12', type: 'local', items: [{ value: '3', title: '25%' }, { value: '4', title: '33%' }, { value: '6', title: '50%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false, defaultValue: 'bar' }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },




    'ImageWidget': {
        key: 'ImageWidget',
        label: 'Image Widget',
        icon: '/assets/icons/elements/edit-image.png',
        description: 'Insert dynamic or static image and edit its style',

        features: [],
        parents: ["general"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'source', type: 'ParamsInput', col: '12', information: { label: '{{lang}}Dynamic Source', validTypes: ['ImageInput'], placeholder: '{{lang}}< Custom Source >', required: false } },

            {
                type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}Custom Image', singleRow: true, placeholder: '{{lang}}Select image', required: true, single: true },
                dependencies: [{
                    refKey: 'source', targetKey: 'image',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.source' }, operator: { value: '==' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'required', value: false }] },
                    init: true,
                    // show:true,

                }]
            },

            { key: 'antecedent', type: 'NumberInput', col: '6', information: { label: '{{lang}}Ratio', placeholder: '{{lang}}Antecedent' } },
            { key: 'consequent', type: 'NumberInput', col: '6', information: { label: '\u200B', placeholder: '{{lang}}Consequent' } },

            { key: 'objectFit', type: 'SelectInput', information: { label: '{{lang}}Object fit', default: 'cover', defaultValue: 'cover', type: 'local', items: [{ value: 'cover', title: '{{lang}}Cover' }, { value: 'fit', title: '{{lang}}fit' }, { value: 'fill', title: '{{lang}}Fill' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false, defaultValue: 'bar' }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },




    'VideoWidget': {
        key: 'VideoWidget',
        label: 'Video Widget',
        icon: '/assets/icons/elements/video.png',
        description: 'Insert dynamic or static video and edit its style',

        features: [],
        parents: ["general"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'source', type: 'ParamsInput', col: '12', information: { label: '{{lang}}Dynamic Source', validTypes: ['VideoInput'], placeholder: '{{lang}}< Custom Source >', required: false } },


            { key: 'showCover', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show Cover Image', placeholder: '', required: false } },

            { key: 'showDuration', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show Video Duration', placeholder: '', required: false } },

            {
                type: 'VideoInput', key: 'image', col: '12', information: { label: '{{lang}}Custom Video', singleRow: true, placeholder: '{{lang}}Select Video', required: true, single: true },
                dependencies: [{
                    refKey: 'source', targetKey: 'image',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.source' }, operator: { value: '==' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'required', value: false }] },
                    init: true,
                    // show:true,

                }]
            },

            { key: 'antecedent', type: 'NumberInput', col: '6', information: { label: '{{lang}}Ratio', placeholder: '{{lang}}Antecedent' } },
            { key: 'consequent', type: 'NumberInput', col: '6', information: { label: '\u200B', placeholder: '{{lang}}Consequent' } },

            { key: 'objectFit', type: 'SelectInput', information: { label: '{{lang}}Object fit', default: 'cover', defaultValue: 'cover', type: 'local', items: [{ value: 'cover', title: '{{lang}}Cover' }, { value: 'fit', title: '{{lang}}fit' }, { value: 'fill', title: '{{lang}}Fill' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false, defaultValue: 'bar' }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },




    'VideoWidget': {
        key: 'VideoWidget',
        label: 'Video Widget',
        icon: '/assets/icons/elements/video.png',
        description: 'Insert dynamic or static video and edit its style',

        features: [],
        parents: ["general"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'source', type: 'ParamsInput', col: '12', information: { label: '{{lang}}Dynamic Source', validTypes: ['VideoInput'], placeholder: '{{lang}}< Custom Source >', required: false } },


            { key: 'showCover', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show Cover Image', placeholder: '', required: false } },

            { key: 'showDuration', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show Video Duration', placeholder: '', required: false } },

            {
                type: 'VideoInput', key: 'image', col: '12', information: { label: '{{lang}}Custom Video', singleRow: true, placeholder: '{{lang}}Select Video', required: true, single: true },
                dependencies: [{
                    refKey: 'source', targetKey: 'image',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.source' }, operator: { value: '==' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'required', value: false }] },
                    init: true,
                    // show:true,

                }]
            },

            { key: 'antecedent', type: 'NumberInput', col: '6', information: { label: '{{lang}}Ratio', placeholder: '{{lang}}Antecedent' } },
            { key: 'consequent', type: 'NumberInput', col: '6', information: { label: '\u200B', placeholder: '{{lang}}Consequent' } },

            { key: 'objectFit', type: 'SelectInput', information: { label: '{{lang}}Object fit', default: 'cover', defaultValue: 'cover', type: 'local', items: [{ value: 'cover', title: '{{lang}}Cover' }, { value: 'fit', title: '{{lang}}fit' }, { value: 'fill', title: '{{lang}}Fill' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false, defaultValue: 'bar' }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },






    'AudioWidget': {
        key: 'AudioWidget',
        label: 'Audio Widget',
        icon: '/assets/icons/elements/sound-wave.png',
        description: 'Insert dynamic or static audio and edit its style',

        features: [],
        parents: ["general"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'source', type: 'ParamsInput', col: '12', information: { label: '{{lang}}Dynamic Source', validTypes: ['VideoInput'], placeholder: '{{lang}}< Custom Source >', required: false } },


            { key: 'showCover', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show Cover Image', placeholder: '', required: false } },

            { key: 'showDuration', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show Video Duration', placeholder: '', required: false } },

            {
                type: 'VideoInput', key: 'image', col: '12', information: { label: '{{lang}}Custom Video', singleRow: true, placeholder: '{{lang}}Select Video', required: true, single: true },
                dependencies: [{
                    refKey: 'source', targetKey: 'image',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.source' }, operator: { value: '==' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'required', value: false }] },
                    init: true,
                    // show:true,

                }]
            },

            { key: 'antecedent', type: 'NumberInput', col: '6', information: { label: '{{lang}}Ratio', placeholder: '{{lang}}Antecedent' } },
            { key: 'consequent', type: 'NumberInput', col: '6', information: { label: '\u200B', placeholder: '{{lang}}Consequent' } },

            { key: 'objectFit', type: 'SelectInput', information: { label: '{{lang}}Object fit', default: 'cover', defaultValue: 'cover', type: 'local', items: [{ value: 'cover', title: '{{lang}}Cover' }, { value: 'fit', title: '{{lang}}fit' }, { value: 'fill', title: '{{lang}}Fill' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false, defaultValue: 'bar' }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },







    'ButtonWidget': {
        key: 'ButtonWidget',
        label: 'Button Widget',
        icon: '/assets/icons/elements/cursor.png',
        description: 'Create button for wide range of different porposes for the page',
        features: [],
        parents: ["general"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}text', required: false } },


            { key: 'function', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'View Record', value: 'openEditModal' }, { title: 'Open window', value: 'openWindow' }, { title: 'Download File', value: 'downloadFile' }, { title: 'Trigger an automation', value: 'manualTrigger' }], label: 'Function', placeholder: 'Choose...', required: true } },




            {
                key: 'source', type: 'ParamsInput', col: '12', information: { label: '{{lang}}Source', validTypes: ['ImageInput', 'VideoInput', 'FileInput'], required: false }, showMain: false,
                dependencies: [{
                    refKey: 'function',
                    targetKey: 'source',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.function' }, operator: { value: '==' }, target: { value: 'downloadFile' } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                }],
            },


            {
                key: 'page', type: 'SelectInput', col: '12', information: { label: '{{lang}}pages', type: 'api', address: 'getFrames', filter: { appletHub: '{{appletHub}}', type: 'page' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}pages', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'function',
                    targetKey: 'page',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.function' }, operator: { value: '==' }, target: { value: 'openWindow' } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                }],
            },




            {
                key: 'trigger', type: 'TriggerSelectInput', helperKey: 'triggerFields', col: '12', information: { label: '{{lang}}Trigger', type: 'api', address: 'getManualTriggers', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', value: '_id' }, hint: '{{lang}}Manual triggers of automations are list, please select one of them.', placeholder: '{{lang}}Choose ...', required: true }, showMain: false,
                dependencies: [{
                    refKey: 'function', targetKey: 'trigger',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.function' }, operator: { value: '==' }, target: { value: 'manualTrigger' } } }, },
                        effect: { show: true, }
                    }],
                    else: { show: false, changeData: { key: 'trigger', value: null } },
                    init: true,
                    // show:true,

                }],
            },



            // {
            //     key: 'triggerFields', type: 'FormBuilderInput', col: '12', information: { label: '{{lang}}Dynamic fields', placeholder: '{{lang}}fileds', required: true },
            //     dependencies: [{
            //         refKey: ['function', 'triggerFields'], targetKey: 'triggerFields',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.triggerFields' }, operator: { value: '!=' }, target: { value: null } }, 2: { id: 2, source: { value: '@data.function' }, operator: { value: '==' }, target: { value: 'manualTrigger' } }, } },
            //             effect: { show: true,  }
            //         }],
            //         else: { show: false ,changeData: { key: 'triggerFields', value: null }},
            //         init: true,

            //     }],
            // },

            {
                key: 'triggerData', fieldsKey: 'triggerFields', type: 'FormViewerInput', col: '12', information: { label: '{{lang}}Dynamic fields', placeholder: '{{lang}}fileds', required: true },
                dependencies: [{
                    refKey: ['function', 'triggerFields'], targetKey: 'triggerFields',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.triggerFields' }, operator: { value: '!=' }, target: { value: null } }, 2: { id: 2, source: { value: '@data.function' }, operator: { value: '==' }, target: { value: 'manualTrigger' } }, } },
                        effect: { show: true, }
                    }],
                    else: { show: false, changeData: [{ key: 'triggerData', value: null }, { key: 'triggerFields', value: null }] },
                    init: true,

                }],
            },


            { key: 'background', type: 'ColorInput', col: '12', information: { label: '{{lang}}Background color', placeholder: '{{lang}}Select ...', required: false } },
            { key: 'color', type: 'ColorInput', col: '12', information: { label: '{{lang}}Text color', placeholder: '{{lang}}Select ...', required: false } },

            // { key: 'content', type: 'TextEditorInput', col: '12', information: { label: '{{lang}}content', showToolbar: true, placeholder: '{{lang}}text', style: { minHeight: 150 }, required: true } },
            // { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '4', defaultValue: '12', type: 'local', items: [{ value: '3', title: '25%' }, { value: '4', title: '33%' }, { value: '6', title: '50%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false, defaultValue: 'bar' }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },










    'FileWidget': {
        key: 'FileWidget',
        label: 'File Widget',
        icon: '/assets/icons/elements/chart (2).png',

        features: [],
        parents: ["template"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'source', type: 'ParamsInput', col: '12', information: { label: '{{lang}}Dynamic Source', validTypes: ['FileInput'], placeholder: '{{lang}}< Custom Source >', required: false } },


            { key: 'showIcon', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show Icon', placeholder: '', required: false } },

            { key: 'showFileSize', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show File Size', placeholder: '', required: false } },

            {
                type: 'FileInput', key: 'image', col: '12', information: { label: '{{lang}}Custom File', singleRow: true, placeholder: '{{lang}}Select Video', required: true, single: true },
                dependencies: [{
                    refKey: 'source', targetKey: 'image',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.source' }, operator: { value: '==' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'required', value: false }] },
                    init: true,
                    // show:true,

                }]
            },

            // { key: 'antecedent', type: 'NumberInput', col: '6', information: { label: '{{lang}}Ratio', placeholder: '{{lang}}Antecedent' } },
            // { key: 'consequent', type: 'NumberInput', col: '6', information: { label: '\u200B', placeholder: '{{lang}}Consequent' } },

            // { key: 'objectFit', type: 'SelectInput', information: { label: '{{lang}}Object fit', default: 'cover', defaultValue: 'cover', type: 'local', items: [{ value: 'cover', title: '{{lang}}Cover' }, { value: 'fit', title: '{{lang}}fit' }, { value: 'fill', title: '{{lang}}Fill' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false, defaultValue: 'bar' }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },






    'ProductsWidget': {
        key: 'ProductsWidget',
        label: 'Products Widget',
        icon: '/assets/icons/elements/chart (2).png',

        features: [],
        parents: ["template"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            // { key: 'type', type: 'ImageSelectInput', information: { label: '{{lang}}View Type', default: 'table', inputClass: 'transparent', imageSize: 34, fontWeight: 400, default: 'line', col: '6', type: 'local', items: [{ value: 'table', title: '{{lang}}Table', image: '/assets/icons/applets/database/table.svg' }, { value: 'card', title: '{{lang}}card', image: '/assets/icons/applets/database/card.svg' }, { value: 'calendar', title: '{{lang}}Calendar', image: '/assets/icons/applets/database/calendar.svg' }, { value: 'boards', title: '{{lang}}Boards', image: '/assets/icons/applets/database/kanban.svg' }, { value: 'matrix', title: '{{lang}}Matrix', image: '/assets/icons/applets/database/matrix.svg' }], placeholder: '{{lang}}select', required: true }, showMain: true },

            { key: 'collection', secondKey: 'collectionApplet', type: 'AdvancedMultiTreeSelect', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false }, },

            // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}insertLabel', defaultValue: '{{lang}}Updates', required: true } },

            {
                key: 'view.settings.cardInfo', type: 'CardBuilder', col: '12', information: { label: '{{lang}}Card Builder', placeholder: '{{lang}}Card Builder', inputClass: 'bordered-input p-0', required: true },
                dependencies: [{
                    refKey: 'type', targetKey: 'view.settings.cardInfo',
                    conditions: [{
                        root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'boards' } } } },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,
                    // show:true,

                }]
            },
            {
                key: 'view.settings.cardsInrow', type: 'SelectInput', col: '12', information: { label: '{{lang}}Cards in row', placeholder: '{{lang}}Cards in row', type: 'local', items: [{ value: '1', title: '{{lang}}1 Card' }, { value: '2', title: '{{lang}}2 Cards' }, { value: '3', title: '{{lang}}3 Cards' }, { value: '4', title: '{{lang}}4 Cards' }, { value: '5', title: '{{lang}}5 Cards' }], required: true },
                dependencies: [{
                    refKey: 'type', targetKey: 'view.settings.cardsInrow',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,
                    // show:true,

                }]
            },






            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },
    'ProjectsWidget': {
        key: 'ProjectsWidget',
        label: 'Projects Widget',
        icon: '/assets/icons/elements/chart (2).png',

        features: [],
        parents: ["template"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'allApplets', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show All Tasks', placeholder: '', default: false, required: false } },
            {
                key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, icon: '/assets/icons/forms/date.png', placeholder: '{{lang}}insertLabel', required: true }, disabled: true,
                dependencies: [{
                    refKey: 'allApplets', targetKey: 'applet',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.allApplets' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: false }
                    }],
                    else: { show: true },
                    init: true,
                    // show:true,

                }]
            },

        ],

    },
    'TasksWidget': {
        key: 'TasksWidget',
        label: 'Tasks Widget',
        icon: '/assets/icons/elements/chart (2).png',

        features: [],
        parents: ["template"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            // { key: 'type', type: 'ImageSelectInput', information: { label: '{{lang}}View Type', default: 'table', inputClass: 'transparent', imageSize: 34, fontWeight: 400, default: 'line', col: '6', type: 'local', items: [{ value: 'table', title: '{{lang}}Table', image: '/assets/icons/applets/database/table.svg' }, { value: 'card', title: '{{lang}}card', image: '/assets/icons/applets/database/card.svg' }, { value: 'calendar', title: '{{lang}}Calendar', image: '/assets/icons/applets/database/calendar.svg' }, { value: 'boards', title: '{{lang}}Boards', image: '/assets/icons/applets/database/kanban.svg' }, { value: 'matrix', title: '{{lang}}Matrix', image: '/assets/icons/applets/database/matrix.svg' }], placeholder: '{{lang}}select', required: true }, showMain: true },

            { key: 'allProjects', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Show All Project Tasks', placeholder: '', default: false, required: false } },
            {
                key: 'collection', secondKey: 'collectionApplet', type: 'AdvancedMultiTreeSelect', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false },
                dependencies: [{
                    refKey: 'allProjects', targetKey: 'collection',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.allProjects' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: false }
                    }],
                    else: { show: true },
                    init: true,
                    // show:true,

                }]
            },
            {
                key: 'project', type: 'SelectInput', information: { label: '{{lang}}Project', type: 'api', address: 'getMyProjects', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}select', required: false },
                dependencies: [{
                    refKey: 'allProjects', targetKey: 'project',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.allProjects' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: false }
                    }],
                    else: { show: true },
                    init: true,
                    // show:true,

                }]
            },


            { key: 'options', type: 'MultiSelectInput', information: { label: '{{lang}}Task filter', type: 'local', items: [{ value: 'assignee', title: '{{lang}}Assignee' }, { value: 'myTask', title: '{{lang}}My Task' }], placeholder: '{{lang}}select', required: true }, },

            // {
            //     key: 'view.settings.cardInfo', type: 'CardBuilder', col: '12', information: { label: '{{lang}}Card Builder', placeholder: '{{lang}}Card Builder', inputClass: 'bordered-input p-0', required: true },
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'view.settings.cardInfo',
            //         conditions: [{
            //             root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'boards' } } } },
            //             effect: { show: true }
            //         }],
            //         else: { show: false },
            //         init: true,
            //         // show:true,

            //     }]
            // },
            // {
            //     key: 'view.settings.cardsInrow', type: 'SelectInput', col: '12', information: { label: '{{lang}}Cards in row', placeholder: '{{lang}}Cards in row', type: 'local', items: [{ value: '1', title: '{{lang}}1 Card' }, { value: '2', title: '{{lang}}2 Cards' }, { value: '3', title: '{{lang}}3 Cards' }, { value: '4', title: '{{lang}}4 Cards' }, { value: '5', title: '{{lang}}5 Cards' }], required: true },
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'view.settings.cardsInrow',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } } }, },
            //             effect: { show: true }
            //         }],
            //         else: { show: false },
            //         init: true,
            //         // show:true,

            //     }]
            // },






            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },



    'UpdatesWidget': {
        key: 'UpdatesWidget',
        label: 'Updates list',
        icon: '/assets/icons/elements/notification 2.png',
        description: 'It shows the updates of different frames, applets, and hubs',
        features: [],
        parents: ["system"],

        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', defaultValue: '{{lang}}Updates', required: true } },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },


    'RecentlyWidget': {
        key: 'RecentlyWidget',
        label: 'Recently used',
        icon: '/assets/icons/elements/clock.png',
        description: 'List of recently used applets and hubs',

        features: [],
        parents: ["system"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', defaultValue: '{{lang}}Updates', required: true } },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },





    'DashboardsWidget': {
        key: 'DashboardsWidget',
        label: 'Frames list',
        icon: '/assets/icons/elements/frame.png',
        description: 'Can be used for showing the list of available frames.',
        features: [],
        parents: ["system"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            // { key: 'type', type: 'ImageSelectInput', information: { label: '{{lang}}View Type', default: 'table', inputClass: 'transparent', imageSize: 34, fontWeight: 400, default: 'line', col: '6', type: 'local', items: [{ value: 'table', title: '{{lang}}Table', image: '/assets/icons/applets/database/table.svg' }, { value: 'card', title: '{{lang}}card', image: '/assets/icons/applets/database/card.svg' }, { value: 'calendar', title: '{{lang}}Calendar', image: '/assets/icons/applets/database/calendar.svg' }, { value: 'boards', title: '{{lang}}Boards', image: '/assets/icons/applets/database/kanban.svg' }, { value: 'matrix', title: '{{lang}}Matrix', image: '/assets/icons/applets/database/matrix.svg' }], placeholder: '{{lang}}select', required: true }, showMain: true },

            { key: 'collection', secondKey: 'collectionApplet', type: 'AdvancedMultiTreeSelect', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false }, },

            // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}insertLabel', defaultValue: '{{lang}}Updates', required: true } },

            // {
            //     key: 'view.settings.cardInfo', type: 'CardBuilder', col: '12', information: { label: '{{lang}}Card Builder', placeholder: '{{lang}}Card Builder', inputClass: 'bordered-input p-0', required: true },
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'view.settings.cardInfo',
            //         conditions: [{
            //             root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'boards' } } } },
            //             effect: { show: true }
            //         }],
            //         else: { show: false },
            //         init: true,
            //         // show:true,

            //     }]
            // },
            // {
            //     key: 'view.settings.cardsInrow', type: 'SelectInput', col: '12', information: { label: '{{lang}}Cards in row', placeholder: '{{lang}}Cards in row', type: 'local', items: [{ value: '1', title: '{{lang}}1 Card' }, { value: '2', title: '{{lang}}2 Cards' }, { value: '3', title: '{{lang}}3 Cards' }, { value: '4', title: '{{lang}}4 Cards' }, { value: '5', title: '{{lang}}5 Cards' }], required: true },
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'view.settings.cardsInrow',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } } }, },
            //             effect: { show: true }
            //         }],
            //         else: { show: false },
            //         init: true,
            //         // show:true,

            //     }]
            // },






            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },


    'AccoutSettingWidget': {
        key: 'AccoutSettingWidget',
        label: "Account's info",
        icon: '/assets/icons/elements/user (4).png',
        description: 'Shows the different parts of current account and subscription information',
        features: [],
        parents: ["system"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            // { key: 'type', type: 'ImageSelectInput', information: { label: '{{lang}}View Type', default: 'table', inputClass: 'transparent', imageSize: 34, fontWeight: 400, default: 'line', col: '6', type: 'local', items: [{ value: 'table', title: '{{lang}}Table', image: '/assets/icons/applets/database/table.svg' }, { value: 'card', title: '{{lang}}card', image: '/assets/icons/applets/database/card.svg' }, { value: 'calendar', title: '{{lang}}Calendar', image: '/assets/icons/applets/database/calendar.svg' }, { value: 'boards', title: '{{lang}}Boards', image: '/assets/icons/applets/database/kanban.svg' }, { value: 'matrix', title: '{{lang}}Matrix', image: '/assets/icons/applets/database/matrix.svg' }], placeholder: '{{lang}}select', required: true }, showMain: true },

            { key: 'collection', secondKey: 'collectionApplet', type: 'AdvancedMultiTreeSelect', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false }, },

            // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}insertLabel', defaultValue: '{{lang}}Updates', required: true } },

            // {
            //     key: 'view.settings.cardInfo', type: 'CardBuilder', col: '12', information: { label: '{{lang}}Card Builder', placeholder: '{{lang}}Card Builder', inputClass: 'bordered-input p-0', required: true },
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'view.settings.cardInfo',
            //         conditions: [{
            //             root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'boards' } } } },
            //             effect: { show: true }
            //         }],
            //         else: { show: false },
            //         init: true,
            //         // show:true,

            //     }]
            // },
            // {
            //     key: 'view.settings.cardsInrow', type: 'SelectInput', col: '12', information: { label: '{{lang}}Cards in row', placeholder: '{{lang}}Cards in row', type: 'local', items: [{ value: '1', title: '{{lang}}1 Card' }, { value: '2', title: '{{lang}}2 Cards' }, { value: '3', title: '{{lang}}3 Cards' }, { value: '4', title: '{{lang}}4 Cards' }, { value: '5', title: '{{lang}}5 Cards' }], required: true },
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'view.settings.cardsInrow',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'card' } } }, },
            //             effect: { show: true }
            //         }],
            //         else: { show: false },
            //         init: true,
            //         // show:true,

            //     }]
            // },






            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },







    'SliderWidget': {
        key: 'SliderWidget',
        label: 'Slider Widget',
        icon: '/assets/icons/elements/chart (2).png',

        features: [],
        parents: ["template"],

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        types: [{ key: 'small', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'medium', img: '/assets/images/BingWallpaper.jpg', name: 'small' }, { key: 'large', img: '/assets/images/BingWallpaper.jpg', name: 'small' }],


        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}text', required: false } },
            { key: 'function', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'View Record', value: 'openEditModal' }, { title: 'Open window', value: 'openWindow' }, { title: 'Download File', value: 'downloadFile' }], label: 'Function', placeholder: 'Choose...', required: true } },



            {
                key: 'source', type: 'ParamsInput', col: '12', information: { label: '{{lang}}Source', validTypes: ['ImageInput', 'VideoInput', 'FileInput'], required: false }, showMain: false,
                dependencies: [{
                    refKey: 'function',
                    targetKey: 'source',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.function' }, operator: { value: '==' }, target: { value: 'downloadFile' } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                }],
            },


            {
                key: 'page', type: 'SelectInput', col: '12', information: { label: '{{lang}}pages', type: 'api', address: 'getFrames', filter: { type: 'page' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}pages', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'function',
                    targetKey: 'page',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.function' }, operator: { value: '==' }, target: { value: 'openWindow' } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                }],
            },


            { key: 'background', type: 'ColorInput', col: '12', information: { label: '{{lang}}Background color', placeholder: '{{lang}}Select ...', required: false } },
            { key: 'color', type: 'ColorInput', col: '12', information: { label: '{{lang}}Text color', placeholder: '{{lang}}Select ...', required: false } },

            // { key: 'content', type: 'TextEditorInput', col: '12', information: { label: '{{lang}}content', showToolbar: true, placeholder: '{{lang}}text', style: { minHeight: 150 }, required: true } },
            // { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '4', defaultValue: '12', type: 'local', items: [{ value: '3', title: '25%' }, { value: '4', title: '33%' }, { value: '6', title: '50%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false, defaultValue: 'bar' }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },


    // 'TableWidget': {
    //     key: 'TableWidget',
    //     type: 'TableWidget',
    //     title: 'Table View',
    //     label: 'Table View',
    //     icon: '/assets/icons/elements/chart (2).png',
    //     parents: ['all'],
    //     // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
    //     // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
    //     // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
    //     images: ['/assets/images/BingWallpaper.jpg'],


    //     headers: [
    //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '6', title: '50%' }, { value: '8', title: '66%' }, { value: '9', title: '75%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
    //         // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false }, showMain: true },

    //         {
    //             key: 'thing',
    //             type: 'AdvancedSelectInput',
    //             information: {
    //                 label: '{{lang}}thing',
    //                 address: 'getMyThings',
    //                 filter: { filter: {} },
    //                 fields: { title: 'name', image: 'images', value: '_id' },
    //                 type: 'api',
    //                 isSearchable: true,
    //                 icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
    //                 placeholder: '{{lang}}texts.addThing.findThing',
    //                 required: true,
    //             }
    //         },
    //         {
    //             key: 'characteristic',
    //             type: 'MultiSelectInput',
    //             information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
    //             dependencies: [{
    //                 refKey: 'thing',
    //                 targetKey: 'characteristic',
    //                 conditions: {
    //                     root: {
    //                         id: 'root',
    //                         action: 'and',
    //                         conditions: {
    //                             1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
    //                         }
    //                     },
    //                 },
    //                 show: true,
    //                 init: true,
    //                 changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    //             }],
    //             showMain: false
    //         },

    //         // { key: 'reference', type: 'SelectInput', information: { label: '{{lang}}reference', address: 'getValuesWithData', filter: { page: 'brands' }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}insert', required: true }, showMain: false },

    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],

    // },



    // 'BoardsWidget': {
    //     key: 'BoardsWidget',
    //     label: 'Boards View',
    //     icon: '/assets/icons/elements/chart (2).png',

    //     images: ['/assets/images/BingWallpaper.jpg'],
    //     parents: ['all'],
    //     headers: [
    //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '6', title: '50%' }, { value: '8', title: '66%' }, { value: '9', title: '75%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
    //         // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false }, showMain: true },

    //         {
    //             key: 'thing',
    //             type: 'AdvancedSelectInput',
    //             information: {
    //                 label: '{{lang}}thing',
    //                 address: 'getMyThings',
    //                 filter: { filter: {} },
    //                 fields: { title: 'name', image: 'images', value: '_id' },
    //                 type: 'api',
    //                 isSearchable: true,
    //                 icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
    //                 placeholder: '{{lang}}texts.addThing.findThing',
    //                 required: true,
    //             }
    //         },
    //         {
    //             key: 'characteristic',
    //             type: 'MultiSelectInput',
    //             information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
    //             dependencies: [{
    //                 refKey: 'thing',
    //                 targetKey: 'characteristic',
    //                 conditions: {
    //                     root: {
    //                         id: 'root',
    //                         action: 'and',
    //                         conditions: {
    //                             1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
    //                         }
    //                     },
    //                 },
    //                 show: true,
    //                 init: true,
    //                 changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    //             }],
    //             showMain: false
    //         },

    //         // { key: 'reference', type: 'SelectInput', information: { label: '{{lang}}reference', address: 'getValuesWithData', filter: { page: 'brands' }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}insert', required: true }, showMain: false },

    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],

    // },


    // 'CardsWidget': {
    //     key: 'CardsWidget',
    //     label: 'Cards View',
    //     icon: '/assets/icons/elements/chart (2).png',

    //     images: ['/assets/images/BingWallpaper.jpg'],
    //     parents: ['all'],
    //     headers: [
    //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '6', title: '50%' }, { value: '8', title: '66%' }, { value: '9', title: '75%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
    //         // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false }, showMain: true },

    //         {
    //             key: 'thing',
    //             type: 'AdvancedSelectInput',
    //             information: {
    //                 label: '{{lang}}thing',
    //                 address: 'getMyThings',
    //                 filter: { filter: {} },
    //                 fields: { title: 'name', image: 'images', value: '_id' },
    //                 type: 'api',
    //                 isSearchable: true,
    //                 icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
    //                 placeholder: '{{lang}}texts.addThing.findThing',
    //                 required: true,
    //             }
    //         },
    //         {
    //             key: 'characteristic',
    //             type: 'MultiSelectInput',
    //             information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
    //             dependencies: [{
    //                 refKey: 'thing',
    //                 targetKey: 'characteristic',
    //                 conditions: {
    //                     root: {
    //                         id: 'root',
    //                         action: 'and',
    //                         conditions: {
    //                             1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
    //                         }
    //                     },
    //                 },
    //                 show: true,
    //                 init: true,
    //                 changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    //             }],
    //             showMain: false
    //         },

    //         // { key: 'reference', type: 'SelectInput', information: { label: '{{lang}}reference', address: 'getValuesWithData', filter: { page: 'brands' }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}insert', required: true }, showMain: false },

    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],

    // },


    // 'MatrixWidget': {
    //     key: 'MatrixWidget',
    //     label: 'Matrix View',
    //     icon: '/assets/icons/elements/chart (2).png',

    //     images: ['/assets/images/BingWallpaper.jpg'],
    //     parents: ['all'],
    //     headers: [
    //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '6', title: '50%' }, { value: '8', title: '66%' }, { value: '9', title: '75%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
    //         // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false }, showMain: true },

    //         {
    //             key: 'thing',
    //             type: 'AdvancedSelectInput',
    //             information: {
    //                 label: '{{lang}}thing',
    //                 address: 'getMyThings',
    //                 filter: { filter: {} },
    //                 fields: { title: 'name', image: 'images', value: '_id' },
    //                 type: 'api',
    //                 isSearchable: true,
    //                 icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
    //                 placeholder: '{{lang}}texts.addThing.findThing',
    //                 required: true,
    //             }
    //         },
    //         {
    //             key: 'characteristic',
    //             type: 'MultiSelectInput',
    //             information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
    //             dependencies: [{
    //                 refKey: 'thing',
    //                 targetKey: 'characteristic',
    //                 conditions: {
    //                     root: {
    //                         id: 'root',
    //                         action: 'and',
    //                         conditions: {
    //                             1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
    //                         }
    //                     },
    //                 },
    //                 show: true,
    //                 init: true,
    //                 changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    //             }],
    //             showMain: false
    //         },

    //         // { key: 'reference', type: 'SelectInput', information: { label: '{{lang}}reference', address: 'getValuesWithData', filter: { page: 'brands' }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}insert', required: true }, showMain: false },

    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],

    // },


    // 'CalendarWidget': {
    //     key: 'CalendarWidget',
    //     label: 'Calendar View',
    //     icon: '/assets/icons/elements/chart (2).png',

    //     images: ['/assets/images/BingWallpaper.jpg'],
    //     parents: ['all'],
    //     headers: [
    //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '6', title: '50%' }, { value: '8', title: '66%' }, { value: '9', title: '75%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
    //         // { key: 'type', type: 'SelectInput', information: { label: '{{lang}}Type', default: 'line', type: 'local', items: [{ value: 'bar', title: 'Bar' }, { value: 'pie', title: 'Pie' }, { value: 'line', title: 'Line' }], placeholder: '{{lang}}select', required: false }, showMain: true },

    //         {
    //             key: 'thing',
    //             type: 'AdvancedSelectInput',
    //             information: {
    //                 label: '{{lang}}thing',
    //                 address: 'getMyThings',
    //                 filter: { filter: {} },
    //                 fields: { title: 'name', image: 'images', value: '_id' },
    //                 type: 'api',
    //                 isSearchable: true,
    //                 icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
    //                 placeholder: '{{lang}}texts.addThing.findThing',
    //                 required: true,
    //             }
    //         },
    //         {
    //             key: 'characteristic',
    //             type: 'MultiSelectInput',
    //             information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
    //             dependencies: [{
    //                 refKey: 'thing',
    //                 targetKey: 'characteristic',
    //                 conditions: {
    //                     root: {
    //                         id: 'root',
    //                         action: 'and',
    //                         conditions: {
    //                             1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
    //                         }
    //                     },
    //                 },
    //                 show: true,
    //                 init: true,
    //                 changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    //             }],
    //             showMain: false
    //         },

    //         // { key: 'reference', type: 'SelectInput', information: { label: '{{lang}}reference', address: 'getValuesWithData', filter: { page: 'brands' }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}insert', required: true }, showMain: false },

    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],

    // },


    // 'NetworkMapWidget': {
    //     key: 'NetworkMapWidget',
    //     title: 'Network Map',
    //     label: 'Network Map',


    //     // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
    //     images: ['/assets/images/BingWallpaper.jpg'],


    //     headers: [
    //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '4', title: '33%' }, { value: '6', title: '50%' }, { value: '8', title: '66%' }, { value: '9', title: '75%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },

    //         {
    //             key: 'gateways',
    //             type: 'MultiSelectInput',
    //             information: {
    //                 label: '{{lang}}gateways',
    //                 address: 'getMyThings',
    //                 filter: { filter: { type: 'Gateway' } },
    //                 fields: { title: 'name', image: 'images', value: '_id' },
    //                 type: 'api',
    //                 isSearchable: true,
    //                 icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
    //                 placeholder: '{{lang}}texts.addThing.findThing',
    //                 required: true,
    //             }
    //         },

    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],

    // },



    'ValueWidget': {
        key: 'ValueWidget',
        label: 'Value',

        icon: '/assets/icons/elements/chart (2).png',

        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
        // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        images: ['/assets/images/BingWallpaper.jpg'],
        parents: ['all'],


        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '4', title: '33%' }, { value: '6', title: '50%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            { key: 'unit', type: 'TextInput', col: '12', information: { label: '{{lang}}unit', hint: 'use , to seperate unit for different characteristics, eg: % , deg', default: '', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insert', required: false } },

            {
                key: 'thing',
                type: 'AdvancedSelectInput',
                information: {
                    label: '{{lang}}thing',
                    address: 'getMyThings',
                    filter: { filter: {} },
                    fields: { title: 'name', image: 'images', value: '_id' },
                    type: 'api',
                    isSearchable: true,
                    icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
                    placeholder: '{{lang}}texts.addThing.findThing',
                    required: true,
                }
            },
            {
                key: 'characteristic',
                type: 'MultiSelectInput',
                information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
                dependencies: [{
                    refKey: 'thing',
                    targetKey: 'characteristic',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                }],
                showMain: false
            },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },


    // 'SliderWidget': {
    //     key: 'SliderWidget',
    //     label: 'Slider',
    //     icon: '/assets/icons/elements/chart (2).png',

    //     // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
    //     // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
    //     // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
    //     images: ['/assets/images/BingWallpaper.jpg'],

    //     parents: ['all'],

    //     headers: [
    //         { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, icon: '/assets/icons/forms/date.png', placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
    //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
    //         // { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '3', title: '25%' }, { value: '4', title: '33%' }, { value: '6', title: '50%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
    //         { key: 'min', type: 'NumberInput', col: '4', information: { label: '{{lang}}mininum', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insert', required: true } },
    //         { key: 'max', type: 'NumberInput', col: '4', information: { label: '{{lang}}maximum', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insert', required: true } },
    //         { key: 'steps', type: 'NumberInput', col: '4', information: { label: '{{lang}}step', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insert', required: false } },

    //         {
    //             key: 'thing',
    //             type: 'AdvancedSelectInput',
    //             information: {
    //                 label: '{{lang}}thing',
    //                 address: 'getMyThings',
    //                 filter: { onlyActions: true },
    //                 fields: { title: 'name', image: 'images', value: '_id' },
    //                 type: 'api',
    //                 isSearchable: true,
    //                 icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
    //                 placeholder: '{{lang}}texts.addThing.findThing',
    //                 required: true,
    //             }
    //         },

    //         {
    //             key: 'characteristic',
    //             type: 'SelectInput',
    //             information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
    //             dependencies: [{
    //                 refKey: 'thing',
    //                 targetKey: 'characteristic',
    //                 conditions: {
    //                     root: {
    //                         id: 'root',
    //                         action: 'and',
    //                         conditions: {
    //                             1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
    //                         }
    //                     },
    //                 },
    //                 show: true,
    //                 init: true,
    //                 changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    //             }],
    //             showMain: false
    //         },


    //         {
    //             key: 'action',
    //             type: 'SelectInput',
    //             information: { label: '{{lang}}action', address: 'getCharactristics', filter: { actions: true }, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: false },
    //             dependencies: [{
    //                 refKey: 'thing',
    //                 targetKey: 'action',
    //                 conditions: {
    //                     root: {
    //                         id: 'root',
    //                         action: 'and',
    //                         conditions: {
    //                             1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
    //                         }
    //                     },
    //                 },
    //                 show: true,
    //                 init: true,
    //                 changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    //             }],
    //             showMain: false
    //         },

    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],

    // },


    'TriggerWidget': {
        key: 'TriggerWidget',
        label: 'Trigger',
        icon: '/assets/icons/elements/chart (2).png',

        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        // 
        images: ['/assets/images/BingWallpaper.jpg'],

        parents: ['all'],
        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insert', required: true } },
            { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '3', type: 'local', items: [{ value: '3', title: '25%' }, { value: '4', title: '33%' }, { value: '6', title: '50%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },

            {
                key: 'thing',
                type: 'AdvancedSelectInput',
                information: {
                    label: '{{lang}}thing',
                    address: 'getMyThings',
                    filter: { onlyActions: true },
                    fields: { title: 'name', image: 'images', value: '_id' },
                    type: 'api',
                    isSearchable: true,
                    icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
                    placeholder: '{{lang}}texts.addThing.findThing',
                    required: true,
                }
            },

            // {
            //     key: 'characteristic',
            //     type: 'SelectInput',
            //     information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
            //     dependencies: [{
            //         refKey: 'thing',
            //         targetKey: 'characteristic',
            //         conditions: {
            //             root: {
            //                 id: 'root',
            //                 action: 'and',
            //                 conditions: {
            //                     1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
            //                 }
            //             },
            //         },
            //         show: true,
            //         init: true,
            //         changeHeader: { key: 'information.filter.id', value: '@data.thing' },

            //     }],
            //     showMain: false
            // },


            {
                key: 'action',
                type: 'SelectInput',
                information: { label: '{{lang}}action', address: 'getCharactristics', filter: { actions: true }, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
                dependencies: [{
                    refKey: 'thing',
                    targetKey: 'action',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                }],
                showMain: false
            },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },


    'StatusSwitcherWidget': {
        key: 'StatusSwitcherWidget',
        label: 'Status Switcher',
        icon: '/assets/icons/elements/chart (2).png',

        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        images: ['/assets/images/BingWallpaper.jpg'],
        parents: ['Messenger'],


        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '3', type: 'local', items: [{ value: '2', title: '16.6%' }, { value: '3', title: '25%' }, { value: '4', title: '33%' }, { value: '6', title: '50%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },

            {
                key: 'thing',
                type: 'AdvancedSelectInput',
                information: {
                    label: '{{lang}}thing',
                    address: 'getMyThings',
                    filter: { filter: {} },
                    fields: { title: 'name', image: 'images', value: '_id' },
                    type: 'api',
                    isSearchable: true,
                    icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
                    placeholder: '{{lang}}texts.addThing.findThing',
                    required: true,
                }
            },
            {
                key: 'characteristic',
                type: 'SelectInput',
                information: { label: '{{lang}}characteristic', address: 'getCharactristics', filter: {}, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
                dependencies: [{
                    refKey: 'thing',
                    targetKey: 'characteristic',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                }],
                showMain: false
            },


            {
                type: 'SubformInput',
                key: 'status',
                col: '12',
                information: {
                    label: '{{lang}}diagram.status',
                    headers: [
                        { type: 'TextInput', key: 'value', col: '6', information: { label: '{{lang}}diagram.value', placeholder: '{{lang}}diagram.value', required: true } },
                        { type: 'ImageInput', key: 'icon', col: '6', information: { label: '{{lang}}diagram.icon', singleRow: true, placeholder: '{{lang}}diagram.label', required: false, single: true } },

                        // IconManagerInput
                    ],
                    placeholder: '{{lang}}placeholders.insertInformation',
                    required: true
                }
            },



            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],

    },

    'QuizPageWidget': {
        key: 'QuizPageWidget',
        label: 'Quiz Page',
        icon: '/assets/icons/elements/chart (2).png',

        // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
        // images: ['/assets/images/BingWallpaper.jpg'],
        features: [],
        parents: ['all'],


        headers: [
            { key: 'collection', type: 'AdvancedMultiTreeSelect', secondKey: 'collectionApplet', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false }, },

            { key: 'view.settings.cardInfo', type: 'CardBuilder', col: '12', information: { label: '{{lang}}Card Builder', placeholder: '{{lang}}Card Builder', inputClass: 'bordered-input p-0', required: true } },
        ],

    },


    // 'MapWidget': {
    //     key: 'MapWidget',
    //     label: 'Map',
    //     icon: '/assets/icons/elements/chart (2).png',

    //     // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#8F82B3', bodyColorE: '#906EA0' },
    //     // icon: 'https://www.flaticon.com/svg/vstatic/svg/1045/1045312.svg?token=exp=1612690478~hmac=8a28653dd776cc3eaaba7990dc6bbd1d',
    //     // icon: 'https://www.flaticon.com/svg/static/icons/svg/768/768903.svg',
    //     // 
    //     images: ['/assets/images/BingWallpaper.jpg'],


    //     headers: [
    //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg', placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '4', title: '33%' }, { value: '6', title: '50%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },

    //         {
    //             key: 'thing',
    //             type: 'AdvancedSelectInput',
    //             information: {
    //                 label: '{{lang}}thing',
    //                 address: 'getMyThings',
    //                 filter: { filter: {} },
    //                 fields: { title: 'name', image: 'images', value: '_id' },
    //                 type: 'api',
    //                 isSearchable: true,
    //                 icon: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg',
    //                 placeholder: '{{lang}}texts.addThing.findThing',
    //                 required: true,
    //             }
    //         },


    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],

    // },

}


export { widgetsList, widgetsGroups }